(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('ConcernSearch', ConcernSearch);

    ConcernSearch.$inject = ['$resource'];

    function ConcernSearch($resource) {
        var resourceUrl =  'api/_search/concerns/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
